import { render, staticRenderFns } from "./PeerReviewPanel.vue?vue&type=template&id=e0a61ff8&"
import script from "./PeerReviewPanel.vue?vue&type=script&lang=js&"
export * from "./PeerReviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./PeerReviewPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports